/**
 * AnnouncementLocationService
 * Service for managing announcement-location associations
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement location CRUD operations
 */
export class AnnouncementLocationService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementLocationService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementLocationService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all locations for a specific announcement
     * GET /api/announcement-locations/by-announcement/{announcementId}
     * @param announcementId - Announcement ID
     * @returns Array of announcement locations
     */
    async getByAnnouncementId(announcementId) {
        const response = await this.getByAnnouncementIdRaw(announcementId);
        return response.data ?? [];
    }
    /**
     * Get all locations for a specific announcement (raw response)
     * @param announcementId - Announcement ID
     */
    getByAnnouncementIdRaw(announcementId) {
        const url = this.buildUrl(`by-announcement/${announcementId}`);
        return this.http.get(url);
    }
    /**
     * Get enriched location views for a specific announcement
     * GET /api/announcement-locations/by-announcement/{announcementId}/views
     * @param announcementId - Announcement ID
     * @returns Array of announcement location model views
     */
    async getViewsByAnnouncementId(announcementId) {
        const response = await this.getViewsByAnnouncementIdRaw(announcementId);
        return response.data ?? [];
    }
    /**
     * Get enriched location views for a specific announcement (raw response)
     * @param announcementId - Announcement ID
     */
    getViewsByAnnouncementIdRaw(announcementId) {
        const url = this.buildUrl(`by-announcement/${announcementId}/views`);
        return this.http.get(url);
    }
}
AnnouncementLocationService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementLocationService.BASE_PATH = 'api/announcement-locations';
//# sourceMappingURL=AnnouncementLocationService.js.map